import React, { Component } from 'react';
import $ from 'jquery';
import Script from 'react-load-script';
import { BrowserRouter as Router, Switch, Route, Link, browserHistory } from 'react-router-dom';
import Helmet from 'react-helmet';

class Contact extends Component {

	render() {
    return (
        <div>
        <Helmet
                title="Contact Us | RAT Films | Creative Film Makers"
                meta={[
                  { name: 'description', content: "Please be free to contact us using the contact form, email or phone. We are always ready to assist you." },
                  

                  ]}
              />
        <section className="page-section contact ">
          <div className="container  dtd-btm-brdr">
            <h3 className="heading main txt-rt">CONTACT</h3>
              <div className="contact-info">
                <p>Please be free to contact us using the form below or email directly:</p>
                <p>Ruchi <a href="mailto:ruchi@ratfilms.in">ruchi@ratfilms.in</a></p>
                <p>Ashutosh <a href="mailto:ashutosh@ratfilms.in">ashutosh@ratfilms.in</a></p>
                <p>Taher <a href="mailto:taher@ratfilms.in">taher@ratfilms.in</a></p>
                <p>Accounts Department <a href="mailto:accounts@ratfilms.in">accounts@ratfilms.in</a></p>
                <p>Information Desk <a href="mailto:info@ratfilms.in">info@ratfilms.in</a></p>
                <p className="last-p">Please be free to contact us using the form below or Telephone directly via <a href="tel:9029500400">9029500400</a></p>
                <h3 className="link-text ft-green">MAILING ADDRESS:</h3>
                <address><p>305 Suvaas, 15th Road, Near Red Chillies Entertainment/ Starbucks Santacruz West. Mumbai.</p></address>
              </div>

              <iframe className="actAsDiv" frameborder="0" height="444" marginheight="0" marginwidth="0" scrolling="no" src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;q=19.075795%2C%2072.831954&amp;aq=0&amp;ie=UTF8&amp;t=m&amp;z=16&amp;iwloc=A&amp;output=embed" width="1114"></iframe>
          </div>
        </section>
		
        </div>

		
    );
  }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/contact.js